import { makeAutoObservable } from "mobx";

class FairnessStore {
  lastResultData = {};
  checkHashData = { hash: "" };
  nextRoundHash = null;

  constructor() {
    makeAutoObservable(this);
  }

  setLastResultData(data) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        this.lastResultData[key] = data[key];
      }
    }
  }

  setCheckHashData(data) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        this.checkHashData[key] = data[key];
      }
    }
  }

  setNextRoundHash(data) {
    this.nextRoundHash = data;
  }

  calculateHash() {
    crypto.subtle
      .digest("SHA-512", new TextEncoder().encode(this.checkHashData.key + this.checkHashData.salt))
      .then((h) => {
        let hexes = [],
          view = new DataView(h);
        for (let i = 0; i < view.byteLength; i += 4)
          hexes.push(("00000000" + view.getUint32(i).toString(16)).slice(-8));
        this.checkHashData.hash = hexes.join("").toUpperCase();
      });
  }
}

export const fairnessStore = new FairnessStore();
